import { useMutation } from '@tanstack/react-query';
import { addFavorite } from '~/apis/pms';

export const usePutAddFavorite = () => {
  return useMutation({
    mutationFn: (params: Parameters<typeof addFavorite>[0]) => addFavorite(params),
  });
};
